export default __webpack_public_path__ + "/assets/news-01.png";